module.exports = __webpack_public_path__ + "static/especialistas-9-9bc25206b7f3c5dafbad38a4c23174c2.jpeg";